// const server = 'http://localhost:6001/'
// const server = 'http://192.168.29.229:6001/'
const server = 'https://billing-server.rean.in/'
export default server
